'use client'

import { m } from 'framer-motion'
import { useMemo } from 'react'

import { mulberry32 } from '@/lib/prng'

export default function MaykopGlobalBackground() {
  const particles = useMemo(() => {
    const count = 50 // Increased density as requested
    const baseSeed = 1337
    return Array.from({ length: count }, (_, i) => {
      const r = mulberry32(baseSeed + i * 101)
      return {
        left: `${(r() * 100).toFixed(6)}%`,
        top: `${(r() * 100).toFixed(6)}%`,
        duration: 3 + r() * 2,
        delay: r() * 2,
        size: r() * 4 + 2, // Sizes from Hero logic roughly
      }
    })
  }, [])

  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
      {/* --- Global Gradients (From Hero) --- */}
      {/* Top Center */}
      <div className="absolute top-[-10%] left-1/2 h-[50vh] w-[80vw] -translate-x-1/2 rounded-full bg-gradient-to-r from-purple-600/20 via-pink-600/15 to-blue-600/20 blur-[150px]" />

      {/* Bottom Left */}
      <div className="absolute bottom-[-10%] left-[-10%] h-[50vw] w-[50vw] rounded-full bg-blue-600/10 blur-[150px]" />

      {/* Middle Right */}
      <div className="absolute top-[40%] right-[-10%] h-[40vw] w-[40vw] rounded-full bg-purple-600/10 blur-[150px]" />

      {/* --- Particles --- */}
      {particles.map((p, i) => (
        <m.div
          key={i}
          className="absolute rounded-full bg-white/30"
          style={{
            left: p.left,
            top: p.top,
            width: Math.max(2, p.size * 0.5), // Scale slightly
            height: Math.max(2, p.size * 0.5),
          }}
          animate={{
            y: [0, -50, 0], // Larger movement for full page
            opacity: [0.2, 0.6, 0.2],
          }}
          transition={{
            duration: p.duration,
            repeat: Infinity,
            delay: p.delay,
            ease: 'linear',
          }}
        />
      ))}

      {/* Base layer to ensure darkness behind gradients */}
      <div className="absolute inset-0 -z-10 bg-[#020617]" />
    </div>
  )
}
